import { BugfixProcessFundingNotifications } from '../components/bugfix-process-funding-notifications'
import { Section } from '../components'


export const ReportsPage = () => {
  return <>
    <Section>
      <h4>Funding Status</h4>
      <BugfixProcessFundingNotifications />
    </Section>
  </>
}